"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = require("@angular/core");
var sis_tree_node_expand_component_1 = require("./sis-tree-node-expand.component");
var sis_tree_node_collapse_component_1 = require("./sis-tree-node-collapse.component");
var sis_tree_node_expand_collapse_component_1 = require("./sis-tree-node-expand-collapse.component");
var operators_1 = require("rxjs/operators");
require("./sis-tree-node.component.css");
var TreeNode = /** @class */ (function () {
    function TreeNode() {
        /**
         * Describes if the node is expanded.
         * @type {boolean}
         */
        this.isExpanded = false;
        /**
         * Describes the parent node.
         * @type {TreeNode}
         */
        this._parent = null;
        this._parent2 = null;
    }
    TreeNode_1 = TreeNode;
    Object.defineProperty(TreeNode.prototype, "parent", {
        get: function () {
            return this._parent;
        },
        set: function (parent) {
            this._parent2 = parent;
            Promise.resolve(function () {
            }).then();
        },
        enumerable: true,
        configurable: true
    });
    TreeNode.prototype.ngAfterContentInit = function () {
        var _this = this;
        this._initChildren();
        this.childNodesSub = this.childNodes.changes
            .pipe(operators_1.delay(0))
            .subscribe(function () { return _this._initChildren(); });
    };
    TreeNode.prototype.ngAfterContentChecked = function () {
        this._parent = this._parent2;
    };
    TreeNode.prototype.ngOnDestroy = function () {
        this.childNodesSub.unsubscribe();
    };
    /**
     * Adds the parent node of all the child nodes.
     * @private
     */
    TreeNode.prototype._initChildren = function () {
        var _this = this;
        this.childNodes.forEach(function (node, index) {
            if (index > 0)
                node.parent = _this;
        });
        this.childExpandNodes.forEach(function (expand) {
            expand.parent = _this;
        });
        this.childCollapseNodes.forEach(function (collapse) {
            collapse.parent = _this;
        });
        this.childExpandCollapseNodes.forEach(function (expandCollapse) {
            expandCollapse.parent = _this;
        });
    };
    /**
     * Expands/Collapses the nodes.
     */
    TreeNode.prototype.toggleExpand = function () {
        this.isExpanded = !this.isExpanded;
    };
    __decorate([
        core_1.Input(),
        __metadata("design:type", Boolean)
    ], TreeNode.prototype, "isExpanded", void 0);
    __decorate([
        core_1.ContentChildren(TreeNode_1),
        __metadata("design:type", core_1.QueryList)
    ], TreeNode.prototype, "childNodes", void 0);
    __decorate([
        core_1.ContentChildren(sis_tree_node_expand_component_1.TreeNodeExpand),
        __metadata("design:type", core_1.QueryList)
    ], TreeNode.prototype, "childExpandNodes", void 0);
    __decorate([
        core_1.ContentChildren(sis_tree_node_collapse_component_1.TreeNodeCollapse),
        __metadata("design:type", core_1.QueryList)
    ], TreeNode.prototype, "childCollapseNodes", void 0);
    __decorate([
        core_1.ContentChildren(sis_tree_node_expand_collapse_component_1.TreeNodeExpandCollapse),
        __metadata("design:type", core_1.QueryList)
    ], TreeNode.prototype, "childExpandCollapseNodes", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", TreeNode),
        __metadata("design:paramtypes", [TreeNode])
    ], TreeNode.prototype, "parent", null);
    TreeNode = TreeNode_1 = __decorate([
        core_1.Component({
            
            selector: "sis-tree-node",
            template: require('./sis-tree-node.component.html'),
        })
        /**
         * TreeNode component provides the user to give custom templates to {@link Tree}.
         * This component represents the nodes of the tree and adds expand/collapse functionality to that nodes.
         * The design for expand/collapse icons can be provided via the following component {@link TreeNodeExpandCollapse}
         */
        ,
        __metadata("design:paramtypes", [])
    ], TreeNode);
    return TreeNode;
    var TreeNode_1;
}());
exports.TreeNode = TreeNode;
//# sourceMappingURL=sis-tree-node.component.js.map